import React from "react";
import { Layout, Tooltip } from "antd";
import { Link } from "react-router-dom";
import { ImTree } from "react-icons/im";
import { toggleCollapsedSideNav } from "../../appRedux/actions";
import { NAV_STYLE_DRAWER, NAV_STYLE_FIXED, NAV_STYLE_MINI_SIDEBAR, TAB_SIZE } from "../../constants/ThemeSetting";
import { useDispatch, useSelector } from "react-redux";
import UserProfile from "../Sidebar/UserProfile";
import SettingsDropdown from "./SettingsDropdown";
import ActionHubButton from "./ActionHubButton";
import PayrollReadinessButton from "./PayrollReadinessButton";
import PunchButton from "../../components/UserProfile/PunchButton";
import LinkedProductsLauncher from "../../components/LinkedProductsLauncher";
import GlobalSearch from "../../components/GlobalSearch";
import { getRoles } from "../../util/getRoles";
import "./Topbar.css";

const { Header } = Layout;

const readAuthUser = () => {
  try {
    return JSON.parse(localStorage.getItem("user_data"));
  } catch (e) {
    return null;
  }
};

const Topbar = () => {
  const { navStyle } = useSelector(({ settings }) => settings);
  const { navCollapsed, width } = useSelector(({ common }) => common);
  const authUser = readAuthUser();
  const companySlug = localStorage.getItem("companyDomain");
  const dispatch = useDispatch();
  const companyName = authUser?.companyId?.companyName;
  const showHamburger =
    navStyle === NAV_STYLE_DRAWER ||
    ((navStyle === NAV_STYLE_FIXED || navStyle === NAV_STYLE_MINI_SIDEBAR) && width < TAB_SIZE);

  return (
    <Header className="app-topbar">
      {showHamburger ? (
        <div className="gx-linebar app-topbar__menu">
          <i
            className="gx-icon-btn icon icon-menu"
            onClick={() => {
              dispatch(toggleCollapsedSideNav(!navCollapsed));
            }}
          />
        </div>
      ) : null}
      <div className="company-name app-topbar__company">
        <h2 title={companyName || undefined}>{companyName}</h2>
      </div>
      <GlobalSearch />
      <ul className="gx-header-notifications app-topbar__actions">
        <li className="gx-language">
          <PunchButton />
        </li>
        <ActionHubButton />
        <PayrollReadinessButton />
        <LinkedProductsLauncher />
        <li className="gx-settings-dropdown">
          <Tooltip title="Organization" placement="bottom" overlayClassName="app-topbar-tooltip">
            <Link
              to={`/${companySlug}/organization-view`}
              className="app-topbar__tile"
              aria-label="Organization Tree"
            >
              <ImTree />
            </Link>
          </Tooltip>
        </li>
        {getRoles(["Admin"]) && (
          <li className="gx-settings-dropdown">
            <SettingsDropdown />
          </li>
        )}
        <UserProfile />
      </ul>
    </Header>
  );
};

export default Topbar;
